import { Button } from '@repo/ui/molecules';

import { useContext } from 'react';
import { CloseDialogContext, MetadataContext } from '../utils/ContextWrapper';
import { useStudyContext } from '../utils/StudyContext';
import { useTranslationsContext } from '../utils/TranslationsContext';
import { getQueryParams } from '../utils/utils';

const closeButtonIds = ['panel-ianmq64zbf'];

export default function CloseButton({ label }: { label?: string }) {
    const queryParams = getQueryParams('answer') || [];
    const { t } = useTranslationsContext();
    const isEmbedded = queryParams.length > 0 ? true : false;

    const { close } = useContext(CloseDialogContext);
    const { study } = useStudyContext();
    const { fullPage } = useContext(MetadataContext);
    const isIframe =
        typeof window === 'undefined' ? false : window.frameElement !== null;

    const showCloseButton =
        fullPage &&
        (isIframe || isEmbedded) &&
        closeButtonIds.includes(study.id);

    return showCloseButton ? (
        <Button
            variant="tertiary"
            children={label ?? t('common.close')}
            onClick={close}
        />
    ) : null;
}
